export default {
  '2017': [
    {
      date: '2017-09-13',
      image: '/images/year-in-review/2017.1.jpg',
      dateDisplay: {
        zh: '9月13日',
        en: '13 September',
      },
      title: {
        zh: '旅遊學院第二次舉辦 “亞太旅遊協會青年座談會”',
        en: 'IFT held the PATA Youth Symposium for the second time',
      }
    },
    {
      date: '2017-10-11',
      image: '/images/year-in-review/2017.2.jpg',
      dateDisplay: {
        zh: '10月11日',
        en: '11 October',
      },
      title: {
        zh: '旅遊學院2017畢業典禮',
        en: 'IFT Graduation Ceremony 2017',
      }
    },
    {
      date: '2017-10-17',
      image: '/images/year-in-review/2017.3.jpg',
      dateDisplay: {
        zh: '10月17日',
        en: '17 October',
      },
      title: {
        zh: '聯合國世界旅遊組織秘書長蒞臨旅遊學院作公開演講，探討亞太區旅遊發展及對人力資源需求和旅遊教育的啟示。',
        en: 'UNWTO Secretary-General shared insights on tourism development in Asia Pacific and implications on HR demand and tourism education at IFT',
      }
    },
    {
      date: '2017-10-23',
      image: '/images/year-in-review/2017.4.jpg',
      dateDisplay: {
        zh: '10月23日',
        en: '23 October',
      },
      title: {
        zh: '旅遊學院與葡萄牙埃武拉大學簽定合作協議，將開展學術交流、交換生課程、實習計劃及學術研究等方面的合作。',
        en: 'IFT signed cooperation agreement with Universidade de Évora, Portugal. IFT will promote faculty and student exchange, internship placement, joint research and other forms of institutional collaboration in postgraduate studies with Universidade de Évora, Portugal.',
      }
    },
    {
      date: '2017-11-11',
      image: '/images/year-in-review/2017.5.jpg',
      dateDisplay: {
        zh: '11月11日',
        en: '11 November',
      },
      title: {
        zh: '旅遊學院於祐漢公園舉行社區日',
        en: 'IFT held community day at Iao Hon Garden',
      }
    },
    {
      date: '2017-11-24',
      image: '/images/year-in-review/2017.6.jpg',
      dateDisplay: {
        zh: '11月24日',
        en: '24 November',
      },
      title: {
        zh: '與里斯本大學合辦 “倫理及旅遊規劃研討會”',
        en: 'IFT and Universidade de Lisboa held a seminar on ethics and tourism planning',
      }
    },
    {
      date: '2017-12-07',
      image: '/images/year-in-review/2017.7.jpg',
      dateDisplay: {
        zh: '12月7日',
        en: '07 December',
      },
      title: {
        zh: '舉辦“澳門職業技能認可基準”2017金襟針大賽及頒獎典禮',
        en: 'IFT organised “Macao Occupational Skills Recognition System” (MORS) 2017 Gold Pin Competition Award Presentation Ceremony',
      }
    },
  ],
  '2018': [
    {
      date: '2018-01-24',
      image: '/images/year-in-review/2018.1.jpg',
      dateDisplay: {
        zh: '1月24日',
        en: '24 January',
      },
      title: {
        zh: '旅遊學院舉辦“就業發展日”，39所機構為應屆畢業生提供就業機會。',
        en: 'IFT held Career Day and 39 organisations offered job opportunities for IFT graduating students',
      }
    },
    {
      date: '2018-02-02',
      image: '/images/year-in-review/2018.2.jpg',
      dateDisplay: {
        zh: '2月2至11日',
        en: '02-11 February',
      },
      title: {
        zh: '旅遊學院總廚譚光湖先生作為澳門旅遊局代表隊成員，到日本北海道參加“第45屆國際雪雕比賽”，澳門隊榮獲第二名。',
        en: 'IFT Head Chef Mr. Tam Kuong Wu attended the 45<sup>th</sup> International Snow Sculpture Competition in Hokkaido, Japan, as a MGTO delegate and won the 2<sup>nd</sup> place with his team.',
      }
    },
    {
      date: '2018-03-05',
      image: '/images/year-in-review/2018.3.jpg',
      dateDisplay: {
        zh: '3月5日',
        en: '05 March',
      },
      title: {
        zh: '旅遊學院與土生葡人美食聯誼會合辦澳門土生菜烹調示範工作坊及美食推廣。',
        en: 'IFT and Confraria da Gastronomia Macaense joined hands to hold Macanese Cuisine Cooking Demonstration and Food Promotion',
      }
    },
    {
      date: '2018-03-29',
      image: '/images/year-in-review/2018.4.jpg',
      dateDisplay: {
        zh: '3月29日',
        en: '29 March',
      },
      title: {
        zh: '在全國政協副主席何厚鏵先生和社會文化司司長譚俊榮博士的見證下，旅遊學院與緬甸聯邦共和國飯店與旅遊部轄下的飯店與旅遊局培訓和教育部門簽署諒解備忘錄，提升緬甸人力資源質素和推動旅遊業可持續發展。',
        en: 'IFT signed a Memorandum of Understanding with Training and Education Department of the Directorate of Hotels and Tourism, Ministry of Hotels and Tourism, Republic of the Union of Myanmar to enhance Myanmar’s human capital for sustainable tourism development. The ceremony was witnessed by Edmund Ho, Vice-Chairman of the Chinese People’s Political Consultative Conference and Dr. Alexis Tam, Secretary for Social Affairs and Culture.',
      }
    },
    {
      date: '2018-04-20',
      image: '/images/year-in-review/2018.5.jpg',
      dateDisplay: {
        zh: '4月20日 ',
        en: '20 April',
      },
      title: {
        zh: '旅遊學院與南開大學合辦“中國‘一帶一路’倡議對全球旅遊業的長遠啟示”國際論壇',
        en: 'IFT organised an international forum with Nankai University on China’s Belt and Road Initiative: Long-term Implications for Global Travel and Tourism',
      }
    },
    {
      date: '2018-04-21',
      image: '/images/year-in-review/2018.6.jpg',
      dateDisplay: {
        zh: '4月21日',
        en: '21 April',
      },
      title: {
        zh: '於氹仔花城公園舉辦“旅遊學院氹仔社區日”',
        en: 'IFT held “IFT Taipa Community Day” at Flower City Garden, Taipa',
      }
    },
    {
      date: '2018-05-02',
      image: '/images/year-in-review/2018.7.jpg',
      dateDisplay: {
        zh: '5月2日',
        en: '02 May',
      },
      title: {
        zh: '旅遊學院與江門職業技術學院簽定合作協議。將建立長效及持續的合作機制，推動旅遊酒店等方面專業技術教育和培訓工作，共建粵港澳大灣區旅遊行業資格標準，並在大灣區相關院校和旅遊行業推廣，以及進行各種相關的交流合作活動。',
        en: 'IFT and Jiangmen Polytechnic signed cooperation agreement, it is hoped to assist in the development of the Greater Bay Area, giving full play to the advantages of the higher education institutions in the areas, and deepen exchanges and cooperation in education between the two regions. The implementation of the agreement facilitated talent cultivation in both regions, as to cope with rapid the industry development.',
      }
    },
    {
      date: '2018-05-08',
      image: '/images/year-in-review/2018.8.jpg',
      dateDisplay: {
        zh: '5月8日',
        en: '08 May',
      },
      title: {
        zh: '旅遊學院旅遊業研究暨科研中心與中山大學旅遊學院、香港理工大學酒店及旅遊業管理學院合辦大灣區旅遊研究合作論壇',
        en: 'IFT’s Tourism Research Centre (ITRC), the School of Tourism Management, Sun Yat-Sen University (SYS), and the School of Hotel and Tourism Management, Hong Kong Polytechnic University (HKPU) jointly organised The Greater Bay Area Collaborative Tourism Research Forum.',
      }
    },
    {
      date: '2018-06-13',
      image: '/images/year-in-review/2018.9.jpg',
      dateDisplay: {
        zh: '6月13日',
        en: '13 June',
      },
      title: {
        zh: '與麗景灣藝術酒店合作舉辦“旅遊教育學生峰會2018”',
        en: 'IFT honed management skills via its Tourism Education Student Summit 2018 hosted by Regency Art Hotel',
      }
    },
    {
      date: '2018-06-22',
      image: '/images/year-in-review/2018.10.jpg',
      dateDisplay: {
        zh: '6月22日',
        en: '22 June',
      },
      title: {
        zh: '旅遊學院2018畢業典禮',
        en: 'IFT Graduation Ceremony 2018',
      }
    },
    {
      date: '2018-06-26',
      image: '/images/year-in-review/2018.11.jpg',
      dateDisplay: {
        zh: '6月26日',
        en: '26 June',
      },
      title: {
        zh: '旅遊學院與馬來西亞泰萊大學簽署交換生協議。按照協議內容，雙方將於每學期互派四名合資格交換生，或是每學年互派兩名合資格交換生。',
        en: 'IFT signed a student exchange agreement with Taylor’s University, Malaysia. On an annual basis, each Party will nominate 4 qualified students to the other for a semester or 2 qualified students for the period of 1 year.',
      }
    },
  ]
}
